import { Link, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

export default function InfoTerms() {
	const { translate } = useLocales();

	return (
		<Typography
			fontSize={{ xs: 11, sm: 13 }}
			variant='body1'
			maxWidth={450}
			color={"text.secondary"}
		>
			{translate("customization.terms_1")}
			<Link
				href={"https://www.vumi.io/terminos-y-condiciones"}
				rel='noopener'
				color={"primary.main"}
				sx={{
					"&:hover": {
						textDecoration: "underline"
					}
				}}
				target='_blank'
				underline='none'
			>
				{translate("customization.terms_2")}
			</Link>
			{translate("customization.terms_3")}
			<Link
				href={"https://www.vumi.io/politica-de-seguridad"}
				rel='noopener'
				color={"primary.main"}
				sx={{
					"&:hover": {
						textDecoration: "underline"
					}
				}}
				target='_blank'
				underline='none'
			>
				{translate("customization.terms_4")}
			</Link>
			{translate("customization.terms_5")}
		</Typography>
	);
}
